var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "virtualDom",
    staticClass: "content",
    attrs: {
      "id": 'virtualDom-' + _vm.index
    }
  }, [_vm._t("default", null, {
    "visibleDom": _vm.visiableDom
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };